export const style = {
  h4: {
    fontSize: `20px`,
    fontWeight: 300,
    lineHeight: `27px`,
    margin: `0 0 14px 0`
  },
  h4Bold: {
    fontWeight: `bold`
  },
  p: {
    fontSize: `14px`,
    color: `#666`
  },
  link: {
    color: `#a94545`,
    textStyle: `italic`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Partnets/style/sidebar.js